import { useState, useEffect, useCallback } from 'react';
import API from './phx';
import * as utils from '../utils/OrderUtils';

const getTicketValidityText = (ticketTitle, date, productId) => {
  const year = date && (date.includes('/') ? date.split('/')[2] : date.split('-')[2]);

  const [ticketValidityText, setTicketValidityText] = useState('');

  let fetchUrl = '';

  const expressPassProductIds = ['344363', '344374', '344381', '344373', '344367', '344362'];

  const threeParkAventureIds = ['345294', '345303', '346233', '346237', '347886'];

  if (ticketTitle && ticketTitle.includes('Disney')) {
    if (ticketTitle.includes('7 Day')) {
      fetchUrl = utils.appendGeoParam(
        '/text?types=ticket_validity_tooltip_disney_7_day',
      );
    } else {
      fetchUrl = utils.appendGeoParam(
        '/text?types=ticket_validity_tooltip_disney',
      );
    }
  } else if (ticketTitle && ticketTitle.includes('SeaWorld')) {
    fetchUrl = utils.appendGeoParam(
      '/text?types=ticket_validity_tooltip_seaworld',
    );
  } else if (ticketTitle && ticketTitle.includes('Universal') && !expressPassProductIds.includes(productId)) {
    if (threeParkAventureIds.includes(productId)) {
      fetchUrl = utils.appendGeoParam('/text?types=ticket_validity_tooltip_universal_three_park_adventure');
    } else {
      fetchUrl = utils.appendGeoParam('/text?types=ticket_validity_tooltip_universal');
    }
  }

  const fetchData = useCallback(async () => {
    const resp = await API.get(fetchUrl);
    const data = await resp?.data;
    if (ticketTitle && ticketTitle.includes('SeaWorld')) {
      let seaworldTicketValidity = data.data[0].body.split('December');
      seaworldTicketValidity = `${seaworldTicketValidity[0]}December ${year}.${seaworldTicketValidity[1]}`;
      setTicketValidityText(seaworldTicketValidity);
    } else {
      setTicketValidityText(data.data[0].body);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return ticketValidityText;
};

export default getTicketValidityText;
